import styled from "styled-components"

export const StyledSliderArrowWrapper = styled.div`
  margin-top: 29px;
`
